import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;

  margin-bottom: 3rem;

  @media (max-width: '320px') {
    grid-template-columns: repeat(1, 1fr);
  }
`;
